import { render, staticRenderFns } from "./DashboardTotalCompany.vue?vue&type=template&id=136d69ce&"
import script from "./DashboardTotalCompany.vue?vue&type=script&lang=js&"
export * from "./DashboardTotalCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports